import { PaintedScene } from '../PaintedScene';

export const SAGE_ROAD_PHASER_KEY = 'SageRoadScene' as const;
export const SAGE_ROAD_MANIFEST_KEY = 's-108-sage-road' as const;

export class SageRoadScene extends PaintedScene {
  constructor() {
    super(SAGE_ROAD_PHASER_KEY, SAGE_ROAD_MANIFEST_KEY);
  }
}
